import { useNavMenus } from '@/utils/hooks/useMenus';
import { useRouter } from 'next/router';
import { useEffect, useMemo, useState } from 'react';
import Image from '@/components/Image';
import ArrowDown from '@/components/svg/ArrowDown';
import ArrowUp from '@/components/svg/ArrowUp';
import Link from 'next/link';
import { filterEmpty } from '@/utils/index';
import { NAV_LINK_CLICKED } from '@/constants/amplitude';
import { useAmplitude } from '@/utils/hooks/useAmplitude';
import Styles from './MobileSubNavigation.module.scss';

const MobileSubNavigation = ({ sport }: { sport?: string }) => {
  const { menuData } = useNavMenus();
  const mobileMenu = menuData?.['Research Mobile'];

  const { logAmplitudeEvent } = useAmplitude();
  const [active, setActive] = useState(false);
  const router = useRouter();
  const menu = useMemo(() => mobileMenu?.menuItems?.find(
    (link) => sport?.toLocaleLowerCase() === link?.text.toLocaleLowerCase(),
  ), [mobileMenu?.menuItems, sport]);

  useEffect(() => {
    setActive(false);
  }, [router.asPath]);

  const title = useMemo(() => {
    if (!menu) return '';
    const { slug } = router.query;
    const numSegments = router.asPath.split('/').length;
    if (numSegments === 2 && slug?.toLocaleString() === menu.text.toLocaleLowerCase()) {
      return menu.text;
    }
    return `${menu.text} News`;
  }, [menu, router.query, router.asPath]);
  if (!menu) return <></>;

  return (
    <div className={Styles.container}>
      <button aria-label="expand menu" type="button" onClick={() => setActive(!active)}>
        <Image width={16} height={16} alt={`${menu.text} icon`} src={menu.iconUrl ?? '/research/images/football-us.svg'} />
        {title}
        <span className={Styles.arrowContainer}>
          {active ? <ArrowUp color="#1381E0" /> : <ArrowDown color="#1381E0" />}
        </span>
      </button>
      {active && (
        <ul>
          {filterEmpty(menu.children || [])?.map((item) => (
            <Link
              key={item.text}
              onClick={() => {
                logAmplitudeEvent(
                  NAV_LINK_CLICKED,
                  {
                    'Link Text': item.text,
                    'Link URL': item.url,
                    Module: 'navigation_menu',
                    Menu: 'mobile_nav',
                  },
                );
              }}
              className={Styles.link}
              href={item?.url ?? ''}
            >
              {item?.text}
            </Link>
          ))}
        </ul>
      )}
    </div>
  );
};
export default MobileSubNavigation;
